import { Injectable } from '@angular/core';
import { SynchronizationsService } from '@proxy/services';
import { firstValueFrom } from 'rxjs';
import { SyncConsts } from '../../AppConsts';
import { LocalDb } from '../local-db';
import { LocalDbConsts } from '../local-db-consts';
import { ShiftSync } from '../objects/shift-sync';

@Injectable({ providedIn: 'root' })
export class ShiftRepository {
  constructor(
    private readonly _db: LocalDb,
    private readonly _syncService: SynchronizationsService
  ) {}

  async refreshShifts(): Promise<void> {
    const table = this._db.shifts;

    let skip = 0;
    let total = 0;

    let shifts: ShiftSync[] = [];

    do {
      const result = await firstValueFrom(
        this._syncService.getShifts({
          skipCount: skip,
          maxResultCount: SyncConsts.PageSize,
        })
      );

      total = result.pagedResult.totalCount;

      shifts = shifts.concat(
        result.pagedResult.items.map(dto => ({
          id: dto.id,
          name: dto.name ?? '',
          startHour: dto.startHour,
          endHour: dto.endHour,
        }))
      );

      skip += SyncConsts.PageSize;
    } while (skip < total);

    await this._db.transaction(LocalDbConsts.localDbReadWriteTransaction, table, async () => {
      await table.clear();
      await table.bulkAdd(shifts);
    });
  }

  async getAll(): Promise<ShiftSync[]> {
    return await this._db.shifts.toArray();
  }

  getById(id: number): Promise<ShiftSync> {
    return this._db.shifts.get(id);
  }
}
